import React from 'react';
import { InnerNavMenu } from './InnerNavMenu';
import contactbg from '../../assets/images/contactbg.jpg'
import farmApper from '../../assets/images/farminMapper.png'
import sideMapping from '../../assets/images/sideMappe.jpg'
import general from '../../assets/images/general.jpg'
import technical from '../../assets/images/technical.jpg'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEnvelope, faEnvelopeOpen, faLocationDot, faMicrophone, faPhone, faUser } from '../../../node_modules/@fortawesome/free-solid-svg-icons/index';
function ContactUs() {
    return (
        <div>
            <InnerNavMenu />
            <div className="aboutus_Banner">
                <div className="container BreadcrumbContent">
                    <h1>Contact Us</h1>
                    <nav>
                        <ol className="breadcrumb">
                            <li className="breadcrumb-item"><a href="#">Home</a></li>
                            <li className="breadcrumb-item active">Contact Us</li>
                        </ol>
                    </nav></div>
                <img src={contactbg} className="img-fluid" alt='Contact Us' />
            </div>
            <div className="contactAddress" id="skipContact">
                <div className="container">
                    <div className="row">
                    <div className="col-md-4 mb-4">
                            <div className="card">
                                <div className="card-body">
                                    <div className="row">
                                        <div className="col-2">
                                            <i><FontAwesomeIcon icon={faUser} /></i>
                                        </div>
                                        <div className="col-10">Sh. Chandan Kumar
Under Secretary (Digital/IT)</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-4">
                            <div className="card">
                                <div className="card-body">
                                    <div className="row">
                                        <div className="col-2">
                                            <i><FontAwesomeIcon icon={faPhone} /></i>
                                        </div>
                                        <div className="col-10"><strong>Phone</strong><br/>
                                        011-23382926</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-4">
                            <div className="card">
                                <div className="card-body">
                                    <div className="row">
                                        <div className="col-2">
                                            <i><FontAwesomeIcon icon={faEnvelopeOpen} /></i>
                                        </div>
                                        <div className="col-10"><strong>
                                            Email Us</strong><br />
                                            us-it@gov.in</div>
                                    </div>
                                </div>
                            </div>
                        </div>


                        <div className="col-md-4">
                            <a href='https://itsupport.da.gov.in/' target='_blank' className='support'>
                            <div className="card">
                                <div className="card-body">
                                    <div className="row">
                                        <div className="col-2">
                                            <i className="bi bi-headset"></i>
                                        </div>
                                        <div className="col-10"><strong>
                                            Support</strong><br />
                                            For any query and issue Click Here </div>
                                    </div>
                                </div>
                            </div></a>
                        </div>
                      
                    </div>
                </div>
            </div>
           
            <div className="container-fluid copyright py-4">
                <div className="container">
                    <div className="row">
                        <div className="col-md-12 col-sm-12 text-center  mb-3 mb-md-0">
                            Website Content Owned & Managed by Department of Agriculture & Farmers Welfare | MoA&FW | Government of India, India

                        </div>
                        <div className="col-md-12 col-sm-12 text-center">
                            Designed and Developed by DAD/IT, Ministry of Agriculture, New Delhi, India.
                        </div>
                    </div>
                </div>
            </div>
        </div>
);
}
export default ContactUs